var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarSolidPerks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7242_20313)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99997 0.5C6.18997 0.5 6.36497 0.609999 6.44997 0.779999L7.87997 3.675L11.075 4.14C11.265 4.165 11.42 4.3 11.48 4.48C11.54 4.66 11.49 4.86001 11.355 4.99001L9.04497 7.24001L9.58997 10.42C9.61997 10.61 9.54497 10.795 9.38997 10.91C9.23497 11.02 9.02997 11.035 8.86497 10.95L6.00997 9.44501L3.15497 10.95C2.98497 11.04 2.77997 11.025 2.62997 10.91C2.47997 10.795 2.39997 10.61 2.42997 10.42L2.97497 7.24001L0.66497 4.99001C0.52997 4.86001 0.47997 4.66 0.53997 4.48C0.59997 4.3 0.754969 4.165 0.944969 4.14L4.13997 3.675L5.56997 0.779999C5.65497 0.609999 5.82997 0.5 6.01997 0.5H5.99997Z",
    fill: "#54565B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7242_20313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarSolidPerks);
export default __webpack_public_path__ + "static/media/icon-star-solid-perks.afc95bf52e225f3a6346f31dea50e058.svg";
export { ForwardRef as ReactComponent };